"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertContractData = (value) => {
    if (typeof (value) === 'boolean') {
        return value ? '1' : '0';
    }
    if (typeof (value) === 'number') {
        return `${value}`;
    }
    return value;
};
//# sourceMappingURL=convertContractData.js.map